<template>
  <div class="game-information">
    <div class="game-information-close"></div>
    <div class="tt-tabs gtab">
      <div class="index-tabs">
        <span @click="this.tabActive = 0" :class="`gtab-reg-tab ${this.tabActive === 0 ? 'active-ttab' : ''}`"
          >Регистрация</span
        >
        <span
          v-if="tournamentsTypesLastActive"
          @click="this.tabActive = 1"
          :class="`gtab-reg-tur ${this.tabActive === 1 ? 'active-ttab' : ''}`"
          >Турниры</span
        >
      </div>
      <div class="index-panel">
        <div v-if="this.tabActive === 0" class="tt-panel panel-reg">
          <div class="gtab-title">Зарегистрируйся<br />и получи бонусы</div>

          <div class="gtab-bonus">
            <div class="gtab-bonus-title">Бонус до 250% + 30 FS</div>
            <img src="/images/gtab-check.svg" class="gtab-check" alt="" />
          </div>

          <div class="gtab-rega">
            <div class="tt-tabs tabs-reg">
              <div class="index-tabs">
                <span @click="this.regmethod = 'phone'" :class="this.regmethod === 'phone' ? 'active-ttab' : ''"
                  >Телефон</span
                >
                <span @click="this.regmethod = 'email'" :class="this.regmethod === 'email' ? 'active-ttab' : ''"
                  >Почта</span
                >
              </div>
              <div class="index-panel">
                <div v-if="this.regmethod === 'email'" class="tt-panel">
                  <div class="form-line">
                    <input type="text" class="input-base" name="" placeholder="Введите почту" v-model="email" />
                    <span class="error" v-if="emailErrorMessage">{{ emailErrorMessage }}</span>
                  </div>
                  <div class="form-line">
                    <input type="text" name="" class="rwr-input" placeholder="Логин" v-model="username" required />
                  </div>
                  <div class="form-line">
                    <input
                      :type="passwordFieldType"
                      name=""
                      class="rwr-input"
                      placeholder="Пароль"
                      v-model="password"
                      required
                    />
                    <i class="icp" @click="switchVisibility"></i>
                    <span class="error" v-if="passwordErrorMessage">{{ passwordErrorMessage }}</span>
                  </div>
                  <div class="form-line">
                    <div class="form-line-promo">
                      <div class="form-line-promo-l">
                        <input type="text" class="input-base" name="" placeholder="Промокод" v-model="promocode" />
                      </div>
                      <currency :setValue="data => (this.currency = data)" :value="this.currency" />
                    </div>
                  </div>
                  <button
                    @click="this.onSubmit"
                    class="orange-btn"
                    style="display: block; text-align: center"
                    :disabled="!email || !password || !username || passwordErrorMessage || emailErrorMessage"
                  >
                    {{ this.isLoading ? 'Подождите' : 'Регистрация' }}
                  </button>
                </div>
                <div v-if="this.regmethod === 'phone'" class="tt-panel">
                  <div class="form-line">
                    <phone :setValue="data => (this.phone = data)" :value="this.phone" />
                  </div>
                  <div class="form-line">
                    <div class="form-line-promo">
                      <div class="form-line-promo-l">
                        <input type="text" class="input-base" name="" placeholder="Промокод" v-model="promocode" />
                      </div>
                      <currency :setValue="data => (this.currency = data)" :value="this.currency" />
                    </div>
                  </div>
                  <button
                    @click="this.onSubmit"
                    class="orange-btn"
                    style="display: block; text-align: center"
                    :disabled="!this.phone"
                  >
                    {{ this.isLoading ? 'Подождите' : 'Регистрация' }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <socials />
        </div>
        <div v-if="tournamentsTypesLastActive && this.tabActive === 1" class="tt-panel panel-t">
          <div class="gtournament">
            <div class="gtournament-title">
              Турнир <i>{{ tournamentsTypesLastActive.title }}</i>
            </div>
            <div class="gtournament-name">
              Призовой фонд <span style="color: #fed02d">{{ tournamentsTypesLastActive.prize }}</span>
            </div>
            <img
              :src="tournamentsTypesLastActive.img"
              :alt="tournamentsTypesLastActive.title"
              class="gtournament-image"
            />

            <vue-countdown
              :time="getTime(new Date(tournamentsTypesLastActive.date_end)) - new Date().getTime()"
              :transform="transformSlotProps"
              v-slot="{ days, hours, minutes, seconds }"
            >
              <div class="gtournament-timer">
                <div class="timeTo timeTo-white" style="font-size: 18px">
                  <div class="first" v-if="days !== 0">
                    {{ days }}
                  </div>
                  <span v-if="days !== 0" style="margin-left: 5px; margin-right: 5px">дней,</span>
                  <div class="first">
                    {{ hours }}
                  </div>
                  <span>:</span>
                  <div class="first">
                    {{ minutes }}
                  </div>
                  <span>:</span>
                  <div>
                    {{ seconds }}
                  </div>
                </div>
              </div>
            </vue-countdown>

            <router-link
              :to="{ name: 'tournament', params: { slug: tournamentsTypesLastActive.slug } }"
              class="gtournament-btn"
            >
              Подробнее
            </router-link>

            <div class="gtournament-table-wrap">
              <table class="gtournament-table">
                <thead>
                  <tr>
                    <td>№</td>
                    <td>Логин</td>
                    <td>Приз</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(winner, index) in tournamentsTypesLastActive?.winners" :key="winner.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ winner.username }}</td>
                    <td>
                      <div class="tournaments-table-win-line-money" v-if="winner?.prize?.type === 'money'">
                        {{ winner?.prize?.prize }}
                      </div>
                      <div class="tournaments-table-win-line" v-else-if="winner?.prize?.type === 'prize'">
                        {{ winner?.prize?.prize }}
                      </div>
                      <div class="tournaments-table-win-line-fs" v-else-if="winner?.prize?.type === 'fs'">
                        {{ winner?.prize?.prize }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <router-link
                :to="{ name: 'tournament', params: { slug: tournamentsTypesLastActive.slug } }"
                class="gtournament-table-more"
              >
                Все
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueCountdown from '@chenfengyuan/vue-countdown'
import Socials from '@/components/Socials'
import Currency from '@/components/Fields/Currency'
import Phone from '@/components/Fields/Phone'
import { REGISTER } from '@/store/actions.type'
import { mapGetters } from 'vuex'
import { getTime } from 'date-fns'
import { emailValidation, passwordValidation, transformSlotProps } from '@/utils'
import { toast } from 'vue3-toastify'
import { useI18n } from 'vue-i18n'
import { getSavedRefId } from '@/common/referal'

export default {
  name: 'GameSidebarNoAuth',
  components: { Socials, Currency, Phone, VueCountdown },
  data() {
    return {
      tabActive: 0,
      tabAuth: 0,
      promocode: null,
      phone: null,
      email: null,
      username: null,
      password: null,
      currency: 'RUB',
      regmethod: 'phone',
      isLoading: false,
      passwordFieldType: 'password',
      passwordErrorMessage: null,
      emailErrorMessage: null,
    }
  },
  computed: {
    ...mapGetters(['game', 'winnersWeek', 'gameBySlug', 'tournamentsTypesLastActive', 'favourites', 'isAuthenticated']),
  },
  setup() {
    const { t, locale } = useI18n()
    return { t, locale, getTime, transformSlotProps }
  },
  watch: {
    password: function () {
      this.passwordErrorMessage = passwordValidation(this.username, this.password)
    },
    username: function () {
      if (this.password) {
        this.passwordErrorMessage = passwordValidation(this.username, this.password)
      }
    },
    email: function () {
      if (this.email) {
        this.emailErrorMessage = emailValidation(this.email)
      }
    },
  },
  methods: {
    onSubmit() {
      if (!this.isLoading) {
        this.isLoading = true

        this.$store
          .dispatch(REGISTER, {
            registration_type: this.regmethod,
            username: this.username,
            email: this.email,
            password: this.password,
            currency: this.currency,
            lang: this.locale,
            phone: this.phone,
            ref_id: getSavedRefId(),
          })
          .then(() => {
            this.isLoading = false
            this.$router.push({
              name: 'game',
              params: { game: this.$route.params.game },
              hash: '#reg-success' + (this.regmethod === 'phone' ? '-phone' : ''),
            })
          })
          .catch(res => {
            this.isLoading = false
            toast.error(res?.data?.err)
          })
      }
    },
    switchVisibility() {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
    },
  },
}
</script>

<style scoped></style>
